import React, { ElementType, useEffect, useMemo } from 'react';

import { IDynamicText } from '@/types/contentful';

import { trackWithFingerprint } from '../../utils/trackWithFingerprint';

import { TextProps } from './index';
import { StyledText } from './styles';
import { usePageDataContext } from '../../context/PageData';
import { addAdditionalDataToDynamicText } from '../../utils/addAdditionalDataToDynamicText';
interface ITextWithOptions extends TextProps {
  as?: ElementType<any>;
  className?: string;
  v2?: boolean;
  style?: any;
  keyword: string;
  channel?: string;
  adGroupId?: string;
  fallback: string;
  options?: IDynamicText[];
  module?: string;
}

export function TextWithOptions({
  as: Tag = 'p',
  className,
  v2 = false,
  style,
  keyword,
  channel,
  adGroupId,
  fallback,
  options,
  module,
  ...props
}: ITextWithOptions) {
  const { advocateUserData, query } = usePageDataContext();
  // Find text variation by ad keyword and utm channel
  const value = useMemo(() => {
    const variation = options?.find(
      ({ fields }: IDynamicText) =>
        fields.keyword === keyword &&
        (!adGroupId ||
          (fields.adgroupId && fields.adgroupId.includes(adGroupId))) &&
        fields.channels.includes(channel as string)
    );

    return addAdditionalDataToDynamicText(
      variation?.fields?.text,
      variation?.fields?.keyGeneratedText,
      advocateUserData,
      fallback,
      query
    );
  }, [keyword, channel, options]);

  useEffect(() => {
    if (keyword && channel !== 'organic' && options?.length && !value) {
      trackWithFingerprint('Dynamic Text Failed', {
        module,
        keyword,
        channel,
        allowedOptions: options?.map(({ fields }) => ({
          keyword: fields?.keyword,
          channels: fields?.channels
        }))
      });
    }
  }, [keyword, channel, options, value]);

  if (v2) {
    return (
      <Tag className={className} style={style} {...props}>
        {value ?? fallback}
      </Tag>
    );
  } else {
    return <StyledText {...props}>{value ?? fallback}</StyledText>;
  }
}
